import { createFileRoute } from '@tanstack/react-router';
import { Undo2 } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/devolucoes')({
  component: DevolucoesPage,
});

function DevolucoesPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Mensal"
      title="Devoluções"
      description="Recursos devolvidos ao concedente ou a fornecedores."
      icon={Undo2}
      bullets={[
        'Motivo da devolução e número do ofício',
        'Comprovante de transferência',
        'Vinculação com receita ou pagamento original',
      ]}
      etaLabel="próxima fase"
    />
  );
}
